var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_9365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5418 0.72141C22.7161 2.3749 6.30961 9.46166 1.77716 11.393C-1.2624 12.6297 0.517292 13.789 0.517292 13.789C0.517292 13.789 3.11129 14.7186 5.33654 15.4131C7.56179 16.1103 8.7474 15.3357 8.7474 15.3357L19.2002 7.98714C22.9081 5.35866 22.017 7.52235 21.1284 8.45194C19.2002 10.4634 16.0121 13.6341 13.3439 16.1851C12.1583 17.267 12.7498 18.1966 13.2696 18.6587C15.1978 20.3603 20.4626 23.8409 20.7571 24.0733C22.3243 25.2299 25.4048 26.8941 25.8734 23.3761L27.7274 11.2327C28.3214 7.13502 28.913 3.34455 28.9872 2.26271C29.21 -0.36845 26.5418 0.716067 26.5418 0.716067V0.72141Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_9365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram_icon.6846c04e47b35ed5f1dcbf8591f5b4c6.svg";
export { ForwardRef as ReactComponent };